import React, { useState, useEffect } from 'react';
import './CentrosPage.css';
import baseURL from '../../Components/url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMapMarkerAlt,
    faRotateRight,
    faSpinner,
    faSearch,
    faLayerGroup,
    faUserTie,
    faPhone,
    faClock,
    faBuilding,
    faExternalLinkAlt,
    faTimes
} from '@fortawesome/free-solid-svg-icons';

export default function CentrosPage() {
    // Estados para Centros Perú
    const [centros, setCentros] = useState([]);
    const [zonas, setZonas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [zonaSeleccionada, setZonaSeleccionada] = useState('');
    const [busqueda, setBusqueda] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
        cargarDatos();
    }, []);

    const cargarDatos = () => {
        setLoading(true);
        // Cargar centros de servicios
        fetch(`${baseURL}/centrosServiciosGet.php`)
            .then(res => res.json())
            .then(data => {
                setCentros(data.centros || []);
                setLoading(false);
            })
            .catch(err => {
                console.error('Error al cargar centros:', err);
                setLoading(false);
            });

        // Cargar zonas
        fetch(`${baseURL}/zonasCentrosGet.php`)
            .then(res => res.json())
            .then(data => {
                setZonas(data.zonas || []);
            })
            .catch(err => console.error('Error al cargar zonas:', err));
    };

    const handleRefresh = () => {
        cargarDatos();
    };

    // Filtrado interactivo
    const centrosFiltrados = centros.filter(c => {
        const coincideZona = !zonaSeleccionada ||
            (c.zona && c.zona.toLowerCase().trim() === zonaSeleccionada.toLowerCase().trim());

        const query = busqueda.toLowerCase().trim();
        const coincideTexto = !query ||
            (c.nombre_director && c.nombre_director.toLowerCase().includes(query)) ||
            (c.codigo && c.codigo.toLowerCase().includes(query)) ||
            (c.ciudad && c.ciudad.toLowerCase().includes(query)) ||
            (c.ubicacion && c.ubicacion.toLowerCase().includes(query)) ||
            (c.contacto && c.contacto.toLowerCase().includes(query));

        return coincideZona && coincideTexto;
    });

    return (
        <div className="centros-page-wrapper">
            <div className="centros-page-container">
                {/* Cabecera Principal */}
                <div className="centros-page-header">
                    <div className="centros-title-section">
                        <span className="centros-header-icon">
                            <FontAwesomeIcon icon={faMapMarkerAlt} />
                        </span>
                        <div className="centros-title-text">
                            <h1>Lista de Centros de Servicios DXN</h1>
                            <p>
                                Encuentra tu centro de servicio DXN oficial en el Perú con horarios y contactos actualizados.
                            </p>
                            <div className="centros-header-badge">
                                <span className="centros-pulse-dot"></span>
                                <span>{centros.length} Centros Oficiales Disponibles</span>
                            </div>
                        </div>
                    </div>

                    <div className="centros-page-actions">
                        <button
                            type="button"
                            onClick={handleRefresh}
                            className="btn-centros-action"
                            title="Recargar centros"
                        >
                            <FontAwesomeIcon icon={faRotateRight} />
                            <span>Recargar</span>
                        </button>
                    </div>
                </div>

                {/* Barra de Filtros y Búsqueda */}
                <div className="centros-toolbar-card">
                    <div className="centros-toolbar-grid">
                        {/* Buscador */}
                        <div className="centros-search-box">
                            <FontAwesomeIcon icon={faSearch} className="search-box-icon" />
                            <input
                                type="text"
                                placeholder="Buscar por código, director, ciudad, dirección..."
                                value={busqueda}
                                onChange={(e) => setBusqueda(e.target.value)}
                            />
                            {busqueda && (
                                <button
                                    type="button"
                                    className="btn-clear-input"
                                    onClick={() => setBusqueda('')}
                                    title="Limpiar búsqueda"
                                    aria-label="Limpiar búsqueda"
                                >
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                            )}
                        </div>

                        {/* Selector de Zona */}
                        <div className="centros-zone-select-box">
                            <label htmlFor="select-zona-centros">
                                <FontAwesomeIcon icon={faLayerGroup} />
                                <span>Zona:</span>
                            </label>
                            <select
                                id="select-zona-centros"
                                value={zonaSeleccionada}
                                onChange={(e) => setZonaSeleccionada(e.target.value)}
                                className="select-zona-input"
                            >
                                <option value="">Todas las Zonas ({centros.length})</option>
                                {zonas.map((z) => (
                                    <option key={z.idZona} value={z.nombre_zona}>
                                        {z.nombre_zona} ({z.total_centros || 0})
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>


                </div>

                {/* Contador de Resultados */}
                <div className="centros-results-header">
                    <p>
                        Mostrando <strong>{centrosFiltrados.length}</strong> de {centros.length} centros de servicio
                        {zonaSeleccionada && (
                            <span> en la zona <strong>"{zonaSeleccionada}"</strong></span>
                        )}
                        {busqueda && (
                            <span> para "<strong>{busqueda}</strong>"</span>
                        )}
                    </p>
                </div>

                {/* Listado de Tarjetas */}
                {loading ? (
                    <div className="centros-loading-card">
                        <FontAwesomeIcon icon={faSpinner} spin className="spinner-centros" />
                        <h3>Cargando centros de servicios de DXN Perú...</h3>
                        <p>Obteniendo la información oficial actualizada</p>
                    </div>
                ) : centrosFiltrados.length === 0 ? (
                    <div className="centros-empty-card">
                        <FontAwesomeIcon icon={faBuilding} className="empty-icon" />
                        <h3>No se encontraron centros</h3>
                        <p>No hay centros que coincidan con los criterios seleccionados.</p>
                        <button
                            type="button"
                            className="btn-centros-reset"
                            onClick={() => { setZonaSeleccionada(''); setBusqueda(''); }}
                        >
                            Restablecer Filtros
                        </button>
                    </div>
                ) : (
                    <div className="centros-cards-grid">
                        {centrosFiltrados.map((c) => {
                            const telLimpio = (c.contacto || '').replace(/\D/g, '');
                            return (
                                <div key={c.idCentro} className="centro-item-card">
                                    {/* Director del centro */}
                                    <div className="item-card-director">
                                        <div className="director-icon-wrapper">
                                            <FontAwesomeIcon icon={faUserTie} />
                                        </div>
                                        <div className="director-info">
                                            <span className="director-title">Director / Representante</span>
                                            <h4>{c.nombre_director}</h4>
                                        </div>
                                    </div>

                                    {/* Badges de Zona y Ciudad */}
                                    <div className="item-card-badges">
                                        <span className="tag-zona">{c.zona}</span>
                                        {c.ciudad && <span className="tag-ciudad">{c.ciudad}</span>}
                                    </div>

                                    {/* Información detallada: Ubicación, Contacto, Horario */}
                                    <div className="item-card-info">
                                        {/* Ubicación */}
                                        <div className="info-row info-location">
                                            <FontAwesomeIcon icon={faMapMarkerAlt} className="row-icon marker-icon" />
                                            <div className="row-content">
                                                <p className="location-text">{c.ubicacion}</p>
                                                <a
                                                    href={`https://www.google.com/maps?q=${encodeURIComponent(c.ubicacion)}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn-map-action"
                                                    title="Abrir ubicación en Google Maps"
                                                >
                                                    <FontAwesomeIcon icon={faExternalLinkAlt} />
                                                    <span>Ver en Google Maps</span>
                                                </a>
                                            </div>
                                        </div>

                                        {/* Teléfono / Contacto */}
                                        {c.contacto && (
                                            <div className="info-row info-contact">
                                                <FontAwesomeIcon icon={faPhone} className="row-icon phone-icon" />
                                                <div className="row-content">
                                                    <a
                                                        href={`tel:${telLimpio}`}
                                                        className="btn-phone-action"
                                                        title={`Llamar a ${c.contacto}`}
                                                    >
                                                        <span>{c.contacto}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        )}

                                        {/* Horario */}
                                        {c.horario && (
                                            <div className="info-row info-schedule">
                                                <FontAwesomeIcon icon={faClock} className="row-icon clock-icon" />
                                                <div className="row-content">
                                                    <span className="horario-text">{c.horario}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}
